import type { ReportConfig } from '../ContributionMargin/liveModel';

export const config: ReportConfig = {
  pageId: 'contribution-margin',
  title: 'Contribution Margin Tracker',
  source: 'lux-analytics-prod.analytics.cm_with_marketing_costs',
  date: 'transaction_date_sydt',
  filters: ['region'],
  defaultModel: null,
  views: [
    {
      id: 'daily',
      label: 'Daily CM Tracking',
      card: 'daily',
      dimension: 'day',
      series: 'region',
    },
    {
      id: 'global-monthly',
      label: 'Global Monthly CM Tracking',
      card: 'global_monthly',
      dimension: 'month',
      global: true,
    },
    {
      id: 'regions-monthly',
      label: 'Regions Monthly CM Tracking',
      card: 'monthly',
      dimension: 'month',
      series: 'region',
    },
    {
      id: 'mtd',
      label: 'Regions MTD Expectation',
      card: 'daily',
      dimension: 'day',
      series: 'region',
    },
    { id: 'global-mtd', label: 'Global MTD Expectation', card: 'global_summary', dimension: 'region', global: true },
    {
      id: 'comparison',
      global: true,
      label: 'Comparison Overview',
      card: 'summary',
      dimension: 'region',
    },
    {
      id: 'comparison-chart',
      label: 'Comparison Chart',
      card: 'calendar',
      dimension: 'chart_bucket',
      series: 'region',
    },
    { id: 'legacy', label: 'Sheet 68 · legacy bank fees', card: 'legacy', dimension: 'day', global: true },
    {
      id: 'channels',
      label: 'Marketing spend',
      card: 'channels',
      dimension: 'traffic_channel',
      series: 'region',
    },
  ],
  primary: ['net_cm', 'comparison_cm', 'gross_cm', 'margin_aud_ar', 'cost_aud', 'gross_sales_aud_ar'],
  ratios: {
    gm_rate: ['margin_aud_ar', 'gross_sales_aud_ar'],
    margin_roas: ['margin_aud_ar', 'cost_aud'],
    ttv_roas: ['gross_sales_aud_ar', 'cost_aud'],
    refund_rate: ['total_refund_aud', 'gross_sales_aud_br'],
  },
  definitions: {
    bank_fees:
      'Cash TTV after refunds \u00d7 region rate: AU1.2455%, US/CA3.5932%, SG2.8974%, NZ1.2574%, UK1.6598%, IN2.6716%, Asia+ME3.0357%, other1.3643%.',
    commission: '0.77% of TTV after refunds.',
    comparison_cm:
      'GM AR \u2212 bank fees \u2212 commission \u2212 customer discount \u2212 marketing spend; excludes interest and VCC.',
    net_cm: 'Comparison Net CM + interest income + VCC rebate.',
    gross_cm: 'GM AR \u2212 marketing spend.',
    new_customers: 'Sum of source daily distinct customers, not period-distinct.',
    margin_roas: 'GM after refunds / marketing cost (the workbook labels this ratio Net Margin ROAS).',
  },
  limitations: [
    'Published targets need a governed live source mapping; no snapshot targets are presented as live.',
    'Calendar chart uses source years 2023–2026 and full prior calendar years; current/future Sydney source dates are excluded. MTD and all original cadences still need original visible-value reconciliation.',
    'The CM source has no order/customer identifiers or workbook URL actions; order/customer drill-through needs a documented detail source and join.',
    'Sheet 68 uses its original fixed 22–25 August 2025 window. Legacy region selects the old bank-fee rate independently of row filters.',
    'Net ROAS uses the workbook zero-spend denominator of one. Observed GM % and Refunds % use the source IFNULL zero. MTD GM ratios retain their distinct raw-SUM null boundary.',
  ],
};
